export const learnerDetailsFormResources = {
  addLearnerDetailsTitle: "Add Learner Details",
  addLearner: "Add New Learner",
  noRowsOne: "No rows to display, click the '",
  noRowsTwo: "' button to add a new row.",
  confirmAndSubmit: "Confirm and Submit Attendance",
  confirmationMessage: "I confirm that all the above information is correct and accurate for ",
  totalRows: "Total marked as attended: ",
  error: "Error: ",
  validationErrorMessage:
    "There are missing fields which are required for submission. Columns marked with an asterisk (*) are required.",
  hasDuplicates: "Duplicate emails have been identified.",
  updateForm: "please update the form and try again.",
  emailTaken: " is already taken.",
  invalidEmail: " is not valid",
  emailBlank: "Work Email cannot be blank",
  failedSubmissionPopupTitle: "Fail - Attendance not saved",
  successSubmissionPopupTitle: "Attendance saved successfully",
  modalDescription: "Attendance for",
  failedSubmissionSummaryTwo: "Attendance for the below event has not been saved successfully.",
  cancelPopupHelper: "Click Close to return to the main screen to try again.",
  successfulSubmission: "Attendance for the below event has been saved successfully.",
  successfulPopupHelper: "You will receive an email to confirm attendance has been submitted.",
  checkSubmission: "Are you sure you want to submit attendance for the following event:",
  submitWarning: "Information provided cannot be changed after the attendance list is submitted.",
  proceedPopupHelper:
    "Click ‘Submit’ to submit the form or ‘Cancel’ to return to editing the attendance form.",
  failureReason: "Failure Reason: ",
};
